// Per-channel media size ceilings, mirrored by hand from the backend's
// app/services/channel_limits.py CHANNEL_MEDIA_LIMITS. Keep the two in step
// manually: there is no generated contract between them, so a backend change
// here is a silent FE drift until someone edits this file.
//
// These exist only to fail early and explain why, so staff see "this photo is
// too big for Zalo" in the preview tray instead of watching an upload succeed
// and the send fail afterwards. The backend still validates every item for
// real and its response is the authority — never treat a client-side pass as
// permission to skip reading `items[].status` off the send response.
export const CHANNEL_MEDIA_LIMITS = {
  zalo: { imageMaxBytes: 1 * 1024 * 1024, fileMaxBytes: 5 * 1024 * 1024 },
  facebook: { imageMaxBytes: 25 * 1024 * 1024, fileMaxBytes: 25 * 1024 * 1024 },
}

// The most permissive ceiling a channel could impose, used when the channel is
// unknown or absent. Being permissive is the safer default: the backend
// rejects an oversized item authoritatively, whereas guessing a small limit
// here would block an image the channel would actually have accepted.
export const DEFAULT_IMAGE_MAX_BYTES = 25 * 1024 * 1024

// `channel` arrives in several spellings across the app ('messenger' for
// Facebook, 'widget' for web), so callers pass the already-normalized key from
// normalizeChannelKey() where they have one.
export function getImageMaxBytes(channel) {
  const key = channel ? String(channel).toLowerCase() : null
  return CHANNEL_MEDIA_LIMITS[key]?.imageMaxBytes ?? DEFAULT_IMAGE_MAX_BYTES
}

// Max images the backend's own schema accepts in one send-images batch
// (max_length=10). The preview tray caps selection at this so a batch cannot
// be assembled that the API would reject outright.
export const MAX_BATCH_IMAGES = 10
